import {BaseFilterModel} from "./baseFilter.model";

export class Qref281fzFilter extends BaseFilterModel {
  subjectType = null; // Тип организации
  recordNum = null; // Номер записи
  allName = ''; // ФИО ФЛ
  birthDate = ''; // Дата рождения
  orgName = ''; // Наименование ЮЛ
  regNum = ''; // Регистрационный номер
}

